import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, Input, Button, Table, Label, Form } from "reactstrap"
import { useHistory } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import axios from "axios"
import ReactPaginate from "react-paginate"
import { ToastContainer, toast } from "react-toastify"
import { URLS } from "../../Url"
import { CSVLink } from "react-csv"

function Ventures() {
  const [Actin, setActin] = useState([])
  const [communities, setCommunities] = useState([])
  const [filters, setFilters] = useState({ community: "", categoryName: "" })
  const [categories, setcategories] = useState([])
  const [filter, setFilter] = useState(false)
  const history = useHistory()
  const token = JSON.parse(localStorage.getItem("authUser"))?.token

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  useEffect(() => {
    GetUsers()
    fetchCommunities()
    datass()
    GetAllCategories()
  }, [])

  const GetUsers = () => {
    var token = datas
    axios
      .post(
        URLS.RejectedUserListing,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setActin(res.data.rejecteduserlistings)
      })
  }

  const pagesVisited = pageNumber * listPerPage
  const lists = Actin.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Actin.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

    // categories
    const fetchCommunities = () => {
      axios
        .post(
          "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/community/getall",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(res => {
          if (res.data.success) {
            const userCommunityObjects = res.data.usercommunities.map(
              (community, index) => ({
                _id: `user_${index}`,
                community: community,
              })
            )
  
            // comibing the communities and usercommunities
            const allCommunities = [
              ...(res.data.communities || []),
              ...userCommunityObjects,
            ]
  
            setCommunities(allCommunities)
          } else {
            toast(res.data.message)
          }
        })
    }

    const handleChangeflt = e => {
      setFilters({
        ...filters,
        [e.target.name]: e.target.value,
      })
    }
  
    const getfilter = e => {
      e.preventDefault()
      GetOrderFiliter()
    }
  
    const GetOrderFiliter = () => {
      const bodyData = {
        community: filters.community,
        categoryName: filters.categoryName,
      }
      axios
        .post(URLS.RejectedUserListing, bodyData, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => {
          setActin(res.data.rejecteduserlistings)
          hidefilter()
          setFilters({ community: "", categoryName: "" })
        })
    }
  
    // categories
    const GetAllCategories = () => {
      axios
        .post(
          "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/category/getallcategorys",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(res => {
          if (res.data.success) {
            setcategories(res.data.category)
          } else {
            toast(res.data.message)
          }
        })
    }
  
    const hidefilter = () => setFilter(false)
  
    const handleReset = () => {
      setSearchs({ name: "", email: "", phone: "" })
      setFilters({ community: "", categoryName: "" })
      setPageNumber(0)
      GetUsers()
    }

  const Actinid1 = data => {
    sessionStorage.setItem("ListingId", data.serviceObjectId)
    history.push("/ViewUserListing")
  }

  const datass = () => {
    const location = sessionStorage.getItem("tost")
    if (location != "") {
      toast(location)
      sessionStorage.clear()
    } else {
      sessionStorage.clear()
    }
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  const [Searchs, setSearchs] = useState([])

  const Search = e => {
    let myUser = { ...Searchs }
    myUser[e.target.name] = e.target.value
    setSearchs(myUser)
    var token = datas
    axios
      .post(
        URLS.RejectedUserListingSearch + `${e.target.value}`,
        {},

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setActin(res.data.rejecteduserlistings)
      })
  }

  // excel funtionality
  const headers2 = [
    { label: "S.No", key: "sno" },
    { label: "Listing Id", key: "listingCode" },
    { label: "Listing Name", key: "listingName" },
    { label: "User Name", key: "name" },
    { label: "phone", key: "phone" },
    { label: "Email", key: "email" },
    { label: "Community", key: "community" },
    { label: "Reject Reason", key: "rejectedReason" },
    { label: "Status", key: "status" },
  ]

  const csvData = Actin.map((elt, i) => ({
    sno: i + 1,
    listingCode: elt.listingCode,
    listingName: elt.listingName,
    name: elt.name,
    phone: elt.phone,
    email: elt.email,
    community: elt.community,
    rejectedReason: elt.rejectedReason,
    status: elt.status,
  }))

  const csvReport = {
    filename: "RejectedUserListing.csv",
    headers: headers2,
    data: csvData,
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Home"
            breadcrumbItem="Rejected User listing"
          />
            {filter && (
            <Card>
              <CardBody>
                <Form onSubmit={getfilter}>
                  <Row>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="community-filter">
                          Community 
                        </Label>
                        <select
                          id="community-filter"
                          className="form-select"
                          value={filters.community}
                          name="community"
                          onChange={handleChangeflt}
                        >
                          <option value="">Select</option>
                          {communities.map((community, index) => (
                            <option key={index} value={community.community}>
                              {community.community}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="category-filter">Category</Label>
                        <select
                          id="category-filter"
                          className="form-select"
                          value={filters.categoryName}
                          name="categoryName"
                          onChange={handleChangeflt}
                        >
                          <option value="">Select</option>
                          {categories.map((category, index) => (
                            <option key={index} value={category.name}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mt-4">
                        <Button type="submit" className="m-1" color="info">
                          <i className="fas fa-check-circle"></i> Search
                        </Button>
                        <Button
                          onClick={hidefilter}
                          className="m-1"
                          color="danger"
                        >
                          <i className="fas fa-times-circle"></i> Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          )}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                  <Col>
                      <Button
                        className="m-1"
                        onClick={() => setFilter(!filter)}
                        color="info"
                      >
                        <i className="fas fa-filter"></i> Filter
                      </Button>
                      <Button
                        className="m-1"
                        onClick={handleReset}
                        color="info"
                      >
                        <i className="fas fa-sync-alt"></i> Reset
                      </Button>
                      <CSVLink {...csvReport}>
                        <button
                          className="btn btn-success me-2 m-1"
                          type="button"
                        >
                          <i className="fas fa-file-excel"></i> Excel
                        </button>
                      </CSVLink>
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          name="search"
                          value={Searchs.search}
                          onChange={Search}
                          className="form-control"
                          placeholder="Search.."
                          autoComplete="off"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover className="table table-bordered mb-4">
                      <thead>
                        <tr className="text-center">
                          <th>SlNo</th>
                          <th>Listing Id</th>
                          <th>Listing Name</th>
                          <th>User Name</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Community</th>
                          <th>Business Type </th>
                          <th>Reject Reason</th>
                          <th>Status</th>
                          <th >Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key} className="text-center">
                            <td>{(pageNumber - 1) * 5 + key + 6}</td>
                            <td>
                              <a
                                className="text-primary"
                                onClick={() => {
                                  Actinid1(data)
                                }}
                              >
                                {data.listingCode}
                              </a>
                            </td>
                            <td>{data.listingName}</td>
                            <td>{data.name}</td>
                            <td>{data.phone}</td>
                            <td>{data.email}</td>
                            <td>{data.community}</td>
                            <td>
                              {data.vendor == false ? (
                                <>{"individual"}</>
                              ) : (
                                <></>
                              )}
                            </td>
                            <td>{data.rejectedReason}</td>
                            <td>
                              <span className="badge bg-danger">
                                {data.listingStatus}
                              </span>
                            </td>
                            <td style={{width:"100px"}} >
                              <Button
                                onClick={() => {
                                  Actinid1(data)
                                }}
                                size="sm"
                                className="m-1"
                                color="info"
                              >
                                <div className="d-flex">
                                  <small>
                                    <i className="fas fa-eye m-1"></i>View
                                  </small>
                                </div>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div
                      className="d-flex mt-3 mb-1"
                      style={{ float: "right" }}
                    >
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        total={lists.length}
                      />
                    </div>
                  </div>{" "}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Ventures
